/* eslint react/jsx-key: off */
import * as React from 'react';
import {
  DateTimeInput,
  Edit,
  ReferenceField,
  ReferenceInput,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextField,
  Toolbar,
  TopToolbar,
  usePermissions,
} from 'react-admin';

interface Props {
  [key: string]: any;
}

const SubscriptionEditToolbar: React.FC<Props> = (props) => {
  return (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }} {...props}>
      <SaveButton />
    </Toolbar>
  );
};

const EditActions = () => <TopToolbar>{/* <ShowButton /> */}</TopToolbar>;

const SubscriptionEditForm = () => {
  const { permissions } = usePermissions();

  return (
    <SimpleForm toolbar={<SubscriptionEditToolbar />}>
      <ReferenceField source="user_id" reference="user">
        <TextField source="display_name" />
      </ReferenceField>
      <ReferenceInput source="plan_id" reference="plans">
        <SelectInput optionText={(v) => `(${v.type}) ${v.tier_id} `} validate={required()} />
      </ReferenceInput>
      <DateTimeInput source="current_period_start" />
      <DateTimeInput source="current_period_end" />
    </SimpleForm>
  );
};

const SubscriptionEdit = () => {
  return (
    <Edit actions={<EditActions />} mutationMode="pessimistic">
      <SubscriptionEditForm />
    </Edit>
  );
};

export default SubscriptionEdit;
